import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetPaper } from "../../../services/paper";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import {
  getSinglePaperStart,
  getSinglePaperSuccess,
  getSinglePaperFailure,
} from "../reducer";

export function* getSinglePaper({ payload }) {
  const response = yield call(httpGetPaper, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getSinglePaperSuccess(raw));
  } else {
    yield put(getSinglePaperFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetSinglePaper() {
  yield takeLatest(getSinglePaperStart.type, getSinglePaper);
}
